'use client';
import React from 'react';
import Link from 'next/link';
import useDeviceType from '@/hook/useDeviceType';

const ShowImage = ({ image, mobImage, alt, style, redirectUrl }) => {
    const deviceType = useDeviceType();

    // Avoid rendering until deviceType is known (CSR hydration)
    if (!deviceType) return null;

    const isLaptop = deviceType !== 'mobile';
    const imageUrl = isLaptop ? image : mobImage;

    if (!imageUrl) return null;

    const ImageElement = (
        <img
            className='w-full h-full object-cover'
            alt={alt}
            src={imageUrl}
            loading='lazy'
        />
    );

    return redirectUrl ? (
        <Link href={redirectUrl} target='_blank' className={`block ${style}`}>
            {ImageElement}
        </Link>
    ) : (
        <div className={`${style}`}>
            {ImageElement}
        </div>
    );
};

export default ShowImage;
